import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { UserProvider } from "./context/UserContext";

// Pages
import Landing from "./pages/Landing";
import Dashboard from "./pages/Dashboard";
import Jobs from "./pages/Jobs";
import CreateJob from "./pages/CreateJob";
import JobDetail from "./pages/JobDetail";
import CandidateDetail from "./pages/CandidateDetail";
import Settings from "./pages/Settings";
import Billing from "./pages/Billing";
import Admin from "./pages/Admin";
import PublicJobs from "./pages/PublicJobs";
import PublicJobDetail from "./pages/PublicJobDetail";
import CandidateProfile from "./pages/CandidateProfile";

// Auth Pages
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";

// Components
import Layout from "./components/Layout";
import EmailCapture from "./components/EmailCapture";

function App() {
  return (
    <div className="min-h-screen bg-background">
      <div className="paper-texture" aria-hidden="true" />
      
      <UserProvider>
        <BrowserRouter>
          <EmailCapture />
          <Routes>
            {/* Landing Page - Portal Selection */}
            <Route path="/" element={<Landing />} />
            
            {/* Auth Routes (no layout) */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            
            {/* Routes with Layout (both portals) */}
            <Route element={<Layout />}>
              {/* ===== RECRUITER PORTAL ===== */}
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/jobs" element={<Jobs />} />
              <Route path="/jobs/new" element={<CreateJob />} />
              <Route path="/jobs/:jobId" element={<JobDetail />} />
              <Route path="/candidates/:candidateId" element={<CandidateDetail />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/billing" element={<Billing />} />
              <Route path="/admin" element={<Admin />} />
              
              {/* ===== CANDIDATE PORTAL ===== */}
              <Route path="/empleos" element={<PublicJobs />} />
              <Route path="/jobs/public/:jobId" element={<PublicJobDetail />} />
              <Route path="/candidate/profile" element={<CandidateProfile />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </UserProvider>
      
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
